import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import styled from "styled-components";

export const IconLink = styled("a")`
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const StyledIconButton = styled(Button)`
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const IconButton: React.FC<
  { children?: React.ReactNode } & ButtonProps
> = (props) => {
  return (
    <StyledIconButton variant="link" {...props}>
      {props.children}
    </StyledIconButton>
  );
};
